import { render } from "./pageHome.vue?vue&type=template&id=517d0676&scoped=true"
import script from "./pageHome.vue?vue&type=script&lang=js"
export * from "./pageHome.vue?vue&type=script&lang=js"

import "./pageHome.vue?vue&type=style&index=0&id=517d0676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517d0676"]])

export default __exports__